var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ShoppingCart",
    clipPath: "url(#clip0_1453_6011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9844 19.4062H8.77184C8.37664 19.4062 7.99401 19.2674 7.69064 19.0142C7.38726 18.7609 7.1824 18.4092 7.11176 18.0204L4.42125 3.22418C4.38593 3.02977 4.2835 2.85392 4.13181 2.72729C3.98012 2.60066 3.78881 2.53128 3.59121 2.53125H1.6875",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.85938 23.625C10.0244 23.625 10.9688 22.6806 10.9688 21.5156C10.9688 20.3506 10.0244 19.4062 8.85938 19.4062C7.6944 19.4062 6.75 20.3506 6.75 21.5156C6.75 22.6806 7.6944 23.625 8.85938 23.625Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.9844 23.625C20.1494 23.625 21.0938 22.6806 21.0938 21.5156C21.0938 20.3506 20.1494 19.4062 18.9844 19.4062C17.8194 19.4062 16.875 20.3506 16.875 21.5156C16.875 22.6806 17.8194 23.625 18.9844 23.625Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.59707 15.1875H19.8387C20.2339 15.1874 20.6165 15.0487 20.9199 14.7954C21.2232 14.5422 21.4281 14.1905 21.4987 13.8016L22.7812 6.75H5.0625",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1453_6011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/icon-cart.beece204471cbdf9c4bd35aa15408855.svg";
export { ForwardRef as ReactComponent };